module.exports = __webpack_public_path__ + "static/media/light.b24db3b8.png";